import { ApiError } from "@/api/types";
import { isApiError } from "@/api/utils/isApiError";

interface ErrorMessageProps {
  error: ApiError | Error | null;
  className?: string;
}

export function ErrorMessage({ error, className }: ErrorMessageProps) {
  if (!error) {
    return null;
  }

  let { message } = error;
  const cause = error?.cause?.toString?.();

  if (isApiError(error)) {
    message = error.response?.data?.error?.message || message;
  }

  return (
    <div className={`p-3 bg-red-200 rounded-sm mt-2 ${className}`}>
      {message}
      {cause && <div className="text-sm italic">{cause}</div>}
    </div>
  );
}
